import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  //format a date to a string
  formatDate(date: any) {
    if (date) { 
      const d = new Date(date);
      const month = '' + (d.getMonth() + 1);
      const day = '' + d.getDate();
      const year = d.getFullYear();
      return [year, month, day].join('-');
    }
  }

  checkAndReportErrors(data:any) {
    if (data.error) {
      if (data.error.originalError && data.error.originalError.info && data.error.originalError.info.message) {
        alert(data.error.originalError.info.message);
        throw new TypeError(data.error.originalError.info.message);
      }
    }
  }

}
